/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Push_SubscribedInputs */

const id_notifications_push_subscribed = /** @type {(inputs: Notifications_Push_SubscribedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Berlangganan`)
};

const ms_notifications_push_subscribed = /** @type {(inputs: Notifications_Push_SubscribedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dilanggan`)
};

const da_notifications_push_subscribed = /** @type {(inputs: Notifications_Push_SubscribedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abonneret`)
};

const de_notifications_push_subscribed = /** @type {(inputs: Notifications_Push_SubscribedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abonniert`)
};

const en_us2_notifications_push_subscribed = /** @type {(inputs: Notifications_Push_SubscribedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subscribed`)
};

const es_es2_notifications_push_subscribed = /** @type {(inputs: Notifications_Push_SubscribedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suscrito`)
};

const es_mx2_notifications_push_subscribed = /** @type {(inputs: Notifications_Push_SubscribedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suscrito`)
};

const fil_notifications_push_subscribed = /** @type {(inputs: Notifications_Push_SubscribedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Naka-subscribe`)
};

const fr_notifications_push_subscribed = /** @type {(inputs: Notifications_Push_SubscribedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abonné`)
};

const it_notifications_push_subscribed = /** @type {(inputs: Notifications_Push_SubscribedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iscritto`)
};

const hu_notifications_push_subscribed = /** @type {(inputs: Notifications_Push_SubscribedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Feliratkozva`)
};

const nl_notifications_push_subscribed = /** @type {(inputs: Notifications_Push_SubscribedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geabonneerd`)
};

const no_notifications_push_subscribed = /** @type {(inputs: Notifications_Push_SubscribedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abonnert`)
};

const pl_notifications_push_subscribed = /** @type {(inputs: Notifications_Push_SubscribedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subskrybowany`)
};

const pt_br2_notifications_push_subscribed = /** @type {(inputs: Notifications_Push_SubscribedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subscribed`)
};

const pt_notifications_push_subscribed = /** @type {(inputs: Notifications_Push_SubscribedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subscrito`)
};

const ro_notifications_push_subscribed = /** @type {(inputs: Notifications_Push_SubscribedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abonat`)
};

const fi_notifications_push_subscribed = /** @type {(inputs: Notifications_Push_SubscribedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tilattu`)
};

const sv_notifications_push_subscribed = /** @type {(inputs: Notifications_Push_SubscribedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prenumererar`)
};

const vi_notifications_push_subscribed = /** @type {(inputs: Notifications_Push_SubscribedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã đăng ký`)
};

const tr_notifications_push_subscribed = /** @type {(inputs: Notifications_Push_SubscribedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abone olundu`)
};

const cs_notifications_push_subscribed = /** @type {(inputs: Notifications_Push_SubscribedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přihlášeno`)
};

const bg_notifications_push_subscribed = /** @type {(inputs: Notifications_Push_SubscribedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Абониран`)
};

const ru_notifications_push_subscribed = /** @type {(inputs: Notifications_Push_SubscribedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Подписан`)
};

const uk_notifications_push_subscribed = /** @type {(inputs: Notifications_Push_SubscribedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Підписано`)
};

const ar_notifications_push_subscribed = /** @type {(inputs: Notifications_Push_SubscribedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مشترك`)
};

const hi_notifications_push_subscribed = /** @type {(inputs: Notifications_Push_SubscribedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सब्सक्राइब किया`)
};

const th_notifications_push_subscribed = /** @type {(inputs: Notifications_Push_SubscribedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สมัครรับแล้ว`)
};

const ja_notifications_push_subscribed = /** @type {(inputs: Notifications_Push_SubscribedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`購読中`)
};

const zh_cn2_notifications_push_subscribed = /** @type {(inputs: Notifications_Push_SubscribedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subscribed`)
};

const zh_hant1_notifications_push_subscribed = /** @type {(inputs: Notifications_Push_SubscribedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subscribed`)
};

const ko_notifications_push_subscribed = /** @type {(inputs: Notifications_Push_SubscribedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`구독됨`)
};

/**
* | output |
* | --- |
* | "Subscribed" |
*
* @param {Notifications_Push_SubscribedInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const notifications_push_subscribed = /** @type {((inputs?: Notifications_Push_SubscribedInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Push_SubscribedInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_notifications_push_subscribed(inputs)
	if (locale === "ms") return ms_notifications_push_subscribed(inputs)
	if (locale === "da") return da_notifications_push_subscribed(inputs)
	if (locale === "de") return de_notifications_push_subscribed(inputs)
	if (locale === "en-US") return en_us2_notifications_push_subscribed(inputs)
	if (locale === "es-ES") return es_es2_notifications_push_subscribed(inputs)
	if (locale === "es-MX") return es_mx2_notifications_push_subscribed(inputs)
	if (locale === "fil") return fil_notifications_push_subscribed(inputs)
	if (locale === "fr") return fr_notifications_push_subscribed(inputs)
	if (locale === "it") return it_notifications_push_subscribed(inputs)
	if (locale === "hu") return hu_notifications_push_subscribed(inputs)
	if (locale === "nl") return nl_notifications_push_subscribed(inputs)
	if (locale === "no") return no_notifications_push_subscribed(inputs)
	if (locale === "pl") return pl_notifications_push_subscribed(inputs)
	if (locale === "pt-BR") return pt_br2_notifications_push_subscribed(inputs)
	if (locale === "pt") return pt_notifications_push_subscribed(inputs)
	if (locale === "ro") return ro_notifications_push_subscribed(inputs)
	if (locale === "fi") return fi_notifications_push_subscribed(inputs)
	if (locale === "sv") return sv_notifications_push_subscribed(inputs)
	if (locale === "vi") return vi_notifications_push_subscribed(inputs)
	if (locale === "tr") return tr_notifications_push_subscribed(inputs)
	if (locale === "cs") return cs_notifications_push_subscribed(inputs)
	if (locale === "bg") return bg_notifications_push_subscribed(inputs)
	if (locale === "ru") return ru_notifications_push_subscribed(inputs)
	if (locale === "uk") return uk_notifications_push_subscribed(inputs)
	if (locale === "ar") return ar_notifications_push_subscribed(inputs)
	if (locale === "hi") return hi_notifications_push_subscribed(inputs)
	if (locale === "th") return th_notifications_push_subscribed(inputs)
	if (locale === "ja") return ja_notifications_push_subscribed(inputs)
	if (locale === "zh-CN") return zh_cn2_notifications_push_subscribed(inputs)
	if (locale === "zh-Hant") return zh_hant1_notifications_push_subscribed(inputs)
	return ko_notifications_push_subscribed(inputs)
});
export { notifications_push_subscribed as "notifications.push.subscribed" }